import React from 'react';
import { IconProps } from '.';

const SvgWarehouse = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M20.75 2.25H3.25v19.5h17.5V2.25Zm-3.5 18h2V11.5H4.75v8.75h2v-6h6v-2h4.5v8Zm-3 0h1.5v-6.5h-1.5v6.5Zm-1.5-4.5h-4.5v4.5h4.5v-4.5Zm-8-5.75V3.75h14.5V10h-2V5h-6.5v1h-4v4h-2Zm7.5-3.5V10h3.5V6.5h-3.5Zm-1.5 1h-2.5V10h2.5V7.5Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgWarehouse;
